import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Outlet, useLocation } from "react-router-dom";

const TITLES = {
  "/dashboard":   { title: "Dashboard", subtitle: "Today at a glance" },
  "/tasks":       { title: "Product",   subtitle: "Manage your team's work" },
  "/agent":       { title: "Agent",     subtitle: "AI agents and automations" },
  "/integrations":{ title: "APIs",      subtitle: "Catalog with keys and package costs" },
  "/permissions": { title: "Permissions", subtitle: "Roles and access control" },
  "/cost":        { title: "Cost",      subtitle: "Spending & budgets" },
  "/adoption":    { title: "Adoption",  subtitle: "Usage trends across teams" },
  "/content":     { title: "Content",   subtitle: "Docs, assets, and guides" },
  "/users":       { title: "Users",     subtitle: "Teams, members & permissions" },
  "/accounts":    { title: "Accounts",  subtitle: "Companies, brands & user access" },
};

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const { pathname } = useLocation();
  // Match on the base segment so nested tab routes (e.g. /tasks/product, /agent/seo) keep the title
  const base = "/" + (pathname.split("/")[1] || "");
  const meta = TITLES[pathname] || TITLES[base] || { title: "Three Zinc", subtitle: "" };

  return (
    <div className="h-screen w-full bg-background flex overflow-hidden" data-testid="app-shell">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <Header title={meta.title} subtitle={meta.subtitle} />
        <main className="flex-1 overflow-auto">
          <div className="p-6 md:p-8 animate-fade-up">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
